module.exports = __webpack_public_path__ + "img/img23.36762528.png";